// extracted by mini-css-extract-plugin
export default {"page":"Messages_page__r0RvT","container":"Messages_container__nPOc4","header":"Messages_header__2CN3a","bar":"Messages_bar__MjMTV","table":"Messages_table__ZLKVf"};